
function * generator (start = 0, step = 1) {
  let next = start
  while (true) {
    next += step
    yield next
  }
}

class Generator {
  constructor (start = 0, step = 1) {
    this.start = start
    this.step = step
    this.current = start
    this._generator = generator(this.start, this.step)
    this.hasReset = false
  }

  nextValue () {
    if (this.hasReset) {
      this._generator = generator(this.start, this.step)
      this.hasReset = false
    }
    return (this.current = this._generator.next().value)
  }

  reset (start = 0, step = 1) {
    this.start = start
    this.current = start
    this.step = step
    this.hasReset = true
  }
}

export default Generator
